import { orderUploadErrorsModalStyles } from "@insite/content-library/Components/OrderUploadErrorsModal";
import { css } from "styled-components";

orderUploadErrorsModalStyles.continueButton = {
    variant: "secondary",
    css: css`
            margin-top: 15px;
            float: right;
    `,
};